export function sanitize(s) {
  return s
    .toUpperCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "");
}

export function mask(origin) {
  const symbols = /[ `0123456789!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/;
  let m = "";

  for (const s of origin) {
    if (symbols.test(s)) {
      m += s;
    } else {
      m += "_";
    }
  }

  return m;
}

export function count_symbols(s) {
  return s.replace(/ /g, "").length;
}
